export default {
  getBoardList(state) {
    return state.boardList;
  },

  getAlarmList(state) {
    return state.alarmList;
  },

  getFaqList(state) {
    return state.faqList;
  },

  getPageInfo(state) {
    return state.pageInfo;
  },

  getBoardInfo(state) {
    return state.boardInfo;
  },
  getAlarmInfo(state) {
    return state.alarmInfo;
  }
};
